/* LVC: on mobile product pages keep four tiles by Klarna, hide repeated lower trust strip. */
(()=>{'use strict';
const norm=s=>(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s+/g,' ').trim();
function fix(){
if(!window.matchMedia('(max-width:749px)').matches)return false;
const reviews=document.getElementById('lvc-reviews');if(!reviews)return false;
let found=false;
for(const el of document.querySelectorAll('section,div')){
 if(el.closest('.lv-beneficios.lvc-benefits-cro-mobile'))continue;
 if(!(reviews.compareDocumentPosition(el)&Node.DOCUMENT_POSITION_FOLLOWING))continue;
 const children=[...el.children];if(children.length!==4)continue;
 const txt=children.map(x=>norm(x.textContent));
 if(!txt.some(t=>t.includes('empresa familiar')&&t.includes('desde 1950')))continue;
 if(!txt.some(t=>t.includes('365 dias')))continue;
 if(!txt.some(t=>t.includes('cambio de talla gratis')))continue;
 if(!txt.some(t=>t.includes('envio 24/48h')))continue;
 el.hidden=true;el.style.setProperty('display','none','important');
 el.dataset.lvcCroDeduped='footer';found=true;break;
}
return found;
}
function init(){if(fix())return;const observer=new MutationObserver(()=>{if(fix())observer.disconnect()});observer.observe(document.body,{childList:true,subtree:true});window.addEventListener('load',()=>{fix();setTimeout(()=>observer.disconnect(),4000)},{once:true})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();